export default __webpack_public_path__ + "static/media/banner-academics-new.498492d8.webp";